// @flow weak

import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../fetchTools';

export const getUserInfoData = () => {
  const url = `${getLocationOrigin()}/${appConfig.userInfos.data.API}`;
  const options = {...defaultOptions};

  fetch(url, options)
  .then(checkStatus)
  .then(parseJSON)
  .then(data => data)
  .catch(error => error);
};

export const logout = (postData,key) =>{
  const url = `${getLocationOrigin()}/${appConfig.userInfos.data.API}`;
 
  console.log("action is called")
  fetch(url,{
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'secretkey': key,
        'Authorization':postData 
      },
       body:JSON.stringify()
    })
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};

// export const logout = (postData,key) =>{
//   const url = `${getLocationOrigin()}/${appConfig.userInfos.data.API}`;
 
//   console.log("action is called")
//   fetch(url,{
//       method: 'POST',
//       headers: {
//         'content-type': 'application/json',
//         'secret_key': key,
//         'Authorization':postData 
//       },
//        body:JSON.stringify()
//     })
//      .then((response) => {
//       response.json().then((json) => {
//       dispatch({
//         type: LOGOUT,
//         payload: json
//       })
//     })
//   })
// };





// WEBPACK FOOTER //
// ./src/app/services/API/userInfos.js